export default "__VITE_ASSET__CSNqSk9H__"